import { render, staticRenderFns } from "./BlankEditor.vue?vue&type=template&id=78b79ffe&"
import script from "./BlankEditor.vue?vue&type=script&lang=ts&"
export * from "./BlankEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BlankEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports